import { useTranslation } from 'react-i18next';
import { MarketBanner, MarketButton } from '@market/react';

export const PAYMENT_SDK_ERROR_BANNER_TEST_ID = 'payment-sdk-error-banner';

interface PaymentSdkErrorBannerProps {
  className?: string;
  onRetry: () => void;
}

/**
 * Shown when the Web Payments SDK script could not be loaded (or loaded
 * without attaching its global), so the payment form cannot be mounted.
 */
const PaymentSdkErrorBanner = ({
  className = '',
  onRetry,
}: PaymentSdkErrorBannerProps) => {
  const { t } = useTranslation();

  return (
    <MarketBanner
      className={className}
      variant="critical"
      data-testid={PAYMENT_SDK_ERROR_BANNER_TEST_ID}
    >
      <p>{t('checkout.payment_v3.sdkLoadError.message')}</p>
      <MarketButton slot="action" rank="secondary" onClick={onRetry}>
        {t('checkout.payment_v3.sdkLoadError.retryCTA')}
      </MarketButton>
    </MarketBanner>
  );
};

export default PaymentSdkErrorBanner;
